export const uploadIconStyle = ({
  tokens: {
    font: { size },
  },
}) => ({ fontSize: size.h1 });
